<template>
  <box-label-border :label="label" class="h-full">
    <template v-slot:tools>
      <button @click="copyFleet" :title="$t('components.fleet.copy_tooltip')">
        <icon-copy-list />
      </button>
      <button
        v-if="
          !fleet.lockSpecialists ||
            !fleet.lockResearch ||
            !fleet.lockShips ||
            !fleet.lockDefenses
        "
        @click="clearFleet"
        :title="$t('components.fleet.clear_tooltip')"
      >
        <icon-erase />
      </button>
    </template>
    <template>
      <div class="subfleets-container h-full">
        <debris-gatherer-fleet
          :fleet="fleet"
          :style="{ 'margin-bottom': '1rem' }"
          :simulation-bus="simulationBus"
          :drag-bus="dragBus"
          :item-type-selection-bus="itemTypeSelectionBus"
          :special-ship-bus="specialShipBus"
        ></debris-gatherer-fleet>
      </div>
      <fleet-item-selection :selection-bus="itemTypeSelectionBus" />
      <special-ship-settings :special-ship-bus="specialShipBus" />
    </template>
    <template v-slot:overlay>
      <div
        class="absolute copy-success-overlay top-0 left-0 w-full h-full"
        :class="{
          'copy-success-overlay-visible': showCopySuccessOverlay
        }"
      >
        <span
          class="overlay-text"
          v-html="$t('components.fleet.copy_success')"
        ></span>
      </div>
    </template>
  </box-label-border>
</template>

<script>
import { mapActions } from "vuex";

import BoxLabelBorder from "@/components/boxes/BoxLabelBorder";
import Fleet from "@/store/model/fleet";
import Vue from "vue";
import FleetItemSelection from "@/components/fleet/FleetItemPalette";
import SpecialShipSettings from "@/components/Ships/SpecialShipSettings";
import IconErase from "@/components/icons/icon-erase";
import IconCopyList from "@/components/icons/icon-copyList";
import DebrisGathererFleet from "@/components/fleet/DebrisGathererFleet";

export default {
  name: "DebrisGathererEditor",
  components: {
    DebrisGathererFleet,
    IconCopyList,
    IconErase,
    SpecialShipSettings,
    FleetItemSelection,
    BoxLabelBorder
  },
  props: {
    label: {
      type: String,
      default: "Fleet"
    },
    fleet: {
      type: Fleet,
      required: true
    },
    simulationBus: {
      type: Vue,
      required: true
    },
    dragBus: {
      type: Vue,
      required: true
    }
  },
  data: () => {
    return {
      itemTypeSelectionBus: new Vue(),
      specialShipBus: new Vue(),
      showCopySuccessOverlay: false
    };
  },
  methods: {
    ...mapActions("combat", ["markFleetsChanged"]),
    copyFleet() {
      const fleet = this.fleet;
      const data = fleet.serialize();
      navigator.clipboard.writeText(data);
      this.showCopySuccessOverlay = true;
      setTimeout(() => (this.showCopySuccessOverlay = false), 1000);
    },
    clearFleet() {
      if (!confirm(this.$t("components.fleet.clear_prompt"))) {
        return;
      }

      const fleet = this.fleet;
      fleet.reset();
      this.fleets.splice(1, this.fleets.length - 1);
      this.markFleetsChanged();
    }
  }
};
</script>

<style scoped>
.subfleets-container {
  display: block;
  width: 24rem;
  overflow-x: visible;
  overflow-y: auto;
  padding-top: 1rem;
  box-sizing: border-box;
  margin-left: -2rem;
  margin-right: -2rem;
  padding-left: 2rem;
  padding-right: 2rem;
}
.copy-success-overlay {
  position: relative;
  background-color: var(--color-button-normal);
  border-radius: 0.5rem;
  transition: opacity 0.05s ease-in-out;
  opacity: 0;
}
.copy-success-overlay-visible {
  opacity: 1;
}
.copy-success-overlay span {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 2rem;
}
</style>
